import { lazy } from 'react';

export const NotificationsAsync = lazy(() => import('./notifications.component'));
